import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['email', 'code', 'sendButton', 'verifyButton', 'codeSection', 'message', 'verifiedBadge']

  sendCode() {
    const email = this.emailTarget.value.trim()

    if (email === '') {
      this.showMessage('Ingresa un correo electrónico.', true)
      return
    }

    if (!this.validEmail(email)) {
      this.showMessage('Ingresa un correo electrónico válido.', true)
      return
    }

    this.sendButtonTarget.disabled = true
    this.sendButtonTarget.textContent = 'Enviando...'

    fetch('/denuncias/send_verification_code', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': this.csrfToken()
      },
      body: JSON.stringify({
        email: email
      })
    })
      .then(async response => {
        const data = await response.json()

        if (response.status === 429 && data.retry_after) {
          this.showMessage(data.message, true)

          this.startResendCountdown(data.retry_after)

          return null
        }

        if (!response.ok) {
          throw new Error(data.message || 'No se pudo enviar el código.')
        }

        return data
      })
      .then(data => {
        if (!data) {
          return
        }

        this.codeSectionTarget.classList.remove('hidden')

        this.verifiedBadgeTarget.classList.add('hidden')

        this.codeTarget.value = ''

        this.codeTarget.focus()

        this.showMessage(data.message, false)

        this.startResendCountdown(data.retry_after || 180)
      })
      .catch(error => {
        console.error(error)

        this.showMessage(error.message, true)

        this.sendButtonTarget.disabled = false
        this.sendButtonTarget.textContent = 'Enviar código'

        this.sendButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')

        this.sendButtonTarget.classList.add('cursor-pointer')
      })
  }

  startResendCountdown(seconds) {
    if (this.resendTimer) {
      clearInterval(this.resendTimer)
    }

    let remaining = seconds

    this.sendButtonTarget.disabled = true

    this.updateResendButton(remaining)

    this.resendTimer = setInterval(() => {
      remaining -= 1

      if (remaining <= 0) {
        clearInterval(this.resendTimer)

        this.sendButtonTarget.disabled = false
        this.sendButtonTarget.textContent = 'Reenviar código'

        this.sendButtonTarget.classList.remove('opacity-50', 'cursor-not-allowed')

        this.sendButtonTarget.classList.add('cursor-pointer')

        return
      }

      this.updateResendButton(remaining)
    }, 1000)
  }

  updateResendButton(seconds) {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60

    const formattedSeconds = remainingSeconds.toString().padStart(2, '0')

    this.sendButtonTarget.textContent = `Reenviar código (${minutes}:${formattedSeconds})`

    this.sendButtonTarget.classList.add('opacity-50', 'cursor-not-allowed')

    this.sendButtonTarget.classList.remove('cursor-pointer')
  }

  verifyCode() {
    const code = this.codeTarget.value.trim()

    if (code === '') {
      this.showMessage('Ingresa el código de verificación.', true)
      return
    }

    if (!/^\d{6}$/.test(code)) {
      this.showMessage('El código debe contener 6 dígitos.', true)
      return
    }

    this.verifyButtonTarget.disabled = true
    this.verifyButtonTarget.textContent = 'Verificando...'

    fetch('/denuncias/verify_email_code', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-CSRF-Token': this.csrfToken()
      },
      body: JSON.stringify({
        code: code
      })
    })
      .then(async response => {
        const data = await response.json()

        if (!response.ok) {
          throw new Error(data.message || 'No se pudo verificar el código.')
        }

        return data
      })
      .then(data => {
        this.codeSectionTarget.classList.add('hidden')

        this.verifiedBadgeTarget.classList.remove('hidden')

        this.showMessage(data.message, false)

        this.emailTarget.readOnly = true

        this.sendButtonTarget.classList.add('hidden')
      })
      .catch(error => {
        this.showMessage(error.message, true)
      })
      .finally(() => {
        this.verifyButtonTarget.disabled = false
        this.verifyButtonTarget.textContent = 'Verificar código'
      })
  }

  emailChanged() {
    this.verifiedBadgeTarget.classList.add('hidden')

    if (this.hasCodeSectionTarget) {
      this.codeSectionTarget.classList.add('hidden')
    }

    if (this.hasCodeTarget) {
      this.codeTarget.value = ''
    }

    this.sendButtonTarget.classList.remove('hidden')
    this.sendButtonTarget.textContent = 'Enviar código'

    this.clearMessage()
  }

  showMessage(message, error = false) {
    this.messageTarget.textContent = message

    this.messageTarget.classList.remove('text-red-600', 'text-green-600')

    if (error) {
      this.messageTarget.classList.add('text-red-600')
    } else {
      this.messageTarget.classList.add('text-green-600')
    }
  }

  clearMessage() {
    this.messageTarget.textContent = ''

    this.messageTarget.classList.remove('text-red-600', 'text-green-600')
  }

  validEmail(email) {
    const expression = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return expression.test(email)
  }

  csrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]')

    return token ? token.getAttribute('content') : ''
  }
}
